package org.teddapp.project.db.repo

import app.cash.sqldelight.coroutines.asFlow
import app.cash.sqldelight.coroutines.mapToList
import app.cash.sqldelight.coroutines.mapToOneOrNull
import com.tedd.db.Project
import com.tedd.db.TeddDatabase
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.withContext
import org.teddapp.project.db.newId
import org.teddapp.project.db.nowMillis

class ProjectRepository(private val db: TeddDatabase) {

    fun observeAll(): Flow<List<Project>> =
        db.projectQueries.selectAll().asFlow().mapToList(Dispatchers.Default)

    fun observeByOrganization(organizationId: String): Flow<List<Project>> =
        db.projectQueries.selectByOrganization(organizationId).asFlow().mapToList(Dispatchers.Default)

    fun observeByObjective(objectiveId: String): Flow<List<Project>> =
        db.projectQueries.selectByObjective(objectiveId).asFlow().mapToList(Dispatchers.Default)

    fun observeById(id: String): Flow<Project?> =
        db.projectQueries.selectById(id).asFlow().mapToOneOrNull(Dispatchers.Default)

    suspend fun create(
        organizationId: String,
        name: String,
        color: String,
        icon: String,
        objectiveId: String? = null,
        description: String? = null,
        objectives: String? = null,
        orderIndex: Long = 0,
        id: String = newId("proj"),
    ): String = withContext(Dispatchers.Default) {
        val now = nowMillis()
        db.projectQueries.insert(id, organizationId, objectiveId, name, description, objectives, color, icon, orderIndex, now, now)
        id
    }

    suspend fun update(
        id: String,
        organizationId: String,
        objectiveId: String?,
        name: String,
        description: String?,
        objectives: String?,
        color: String,
        icon: String,
        orderIndex: Long,
    ) = withContext(Dispatchers.Default) {
        db.projectQueries.update(organizationId, objectiveId, name, description, objectives, color, icon, orderIndex, nowMillis(), id)
    }

    suspend fun linkObjective(projectId: String, objectiveId: String?) = withContext(Dispatchers.Default) {
        db.projectQueries.linkObjective(objectiveId, nowMillis(), projectId)
    }

    suspend fun softDelete(id: String) = withContext(Dispatchers.Default) {
        val now = nowMillis()
        db.projectQueries.softDelete(now, now, id)
    }
}